function cleanJsonString(str) {
  return str
    .replace(/^{\s*,/, "{")     // "{," → "{"
    .replace(/\[\s*,/g, "[")    // "[," → "["
    .replace(/,\s*\]/g, "]")    // ",]" → "]"
    .replace(/\{\s*,/g, "{")    // "{," inside objects
    .replace(/,\s*\}/g, "}")    // ",}" → "}"
    .replace(/,,+/g, ",")       // multiple commas → single comma
    .replace(/,\s*,/g, ",")     // ", ," → ","
    .replace(/,\s*$/, "")       // trailing comma at end of string
    .trim();
}

export function normalizePrograms(raw) {
  if (!raw) return [];

  let parsed;

  try {
    const cleaned = cleanJsonString(raw);
    parsed = JSON.parse(cleaned);
  } catch (err) {
    console.error("❌ Failed to parse JSON:", err);
    return [];
  }

  // NEW STRICT SCHEMA
  if (Array.isArray(parsed.steps)) {
    return parsed.steps.map(step => ({
      name: step.name,
      programs: (step.programs || []).map(p => ({
        name: p.name,
        version: p.version || "",
        default_parameters: p.default_parameters || ""
      }))
    }));
  }

  // OLD NESTED SCHEMA
  if (Array.isArray(parsed.processes)) {
    return parsed.processes.map(proc => ({
      name: proc.process,
      programs: (proc.tools || []).map(t => ({
        name: t.name,
        version: t.version || "",
        default_parameters: ""
      }))
    }));
  }

  // OLD FLAT SCHEMA
  if (typeof parsed === "object" && !Array.isArray(parsed)) {
    return Object.entries(parsed).map(([step, tools]) => ({
      name: step,
      programs: (Array.isArray(tools)
        ? tools
        : typeof tools === "string"
        ? [tools]
        : []
      ).map(name => ({
        name,
        version: "",
        default_parameters: ""
      }))
    }));
  }

  return [];
}